export interface PrerequisitesCodeTagsLine {
    prefix: string;
    tags: string[];
    suffix: string;
}

export interface PrerequisitesListItem {
    title: string;
    description: string;
    codeTagsLine?: PrerequisitesCodeTagsLine;
}

export type PrerequisitesProvider = "databricks" | "thoughtspot" | "snowflake";

const DATABRICKS_PREREQUISITES: PrerequisitesListItem[] = [
    {
        title: "Unity Catalog.",
        description: "A Databricks workspace with Unity Catalog enabled.",
    },
    {
        title: "SQL Warehouse.",
        description: "At least one SQL Warehouse in Running or Stopped state.",
    },
    {
        title: "Permissions.",
        description: 'The connecting principal must have "Can use" on the SQL Warehouse',
        codeTagsLine: {
            prefix: "and",
            tags: ["USE CATALOG", "USE SCHEMA"],
            suffix: "on the target Unity Catalog.",
        },
    },
    {
        title: "Network.",
        description: "Blitz must be able to reach your workspace URL over HTTPS (port 443).",
    },
];

const THOUGHTSPOT_PREREQUISITES: PrerequisitesListItem[] = [
    {
        title: "Version.",
        description:
            "ThoughtSpot 9.0.0.cl or later — required for the REST API v2 endpoints Blitz uses.",
    },
    {
        title: "Trusted Authentication.",
        description: "Enabled on your cluster (see Step 2).",
    },
    {
        title: "User account.",
        description:
            "A ThoughtSpot user that can authenticate and access the target data connection.",
    },
    {
        title: "Data connection.",
        description:
            "A connection already created in ThoughtSpot containing the data Blitz will use.",
    },
    {
        title: "Network.",
        description: "Blitz must be able to reach your ThoughtSpot cluster on port 443.",
    },
];

const SNOWFLAKE_PREREQUISITES: PrerequisitesListItem[] = [
    {
        title: "Privileges.",
        description:
            "A Snowflake account with ACCOUNTADMIN or SECURITYADMIN privileges to create users and grant roles.",
    },
    {
        title: "Resources.",
        description:
            "At least one active warehouse, database, and schema that Blitz should query.",
    },
    {
        title: "Network.",
        description: "Blitz must be able to reach your Snowflake account over HTTPS (port 443).",
    },
];

export const PREREQUISITES_BY_PROVIDER: Record<PrerequisitesProvider, PrerequisitesListItem[]> = {
    databricks: DATABRICKS_PREREQUISITES,
    thoughtspot: THOUGHTSPOT_PREREQUISITES,
    snowflake: SNOWFLAKE_PREREQUISITES,
};
